import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

const Home = () => import('@/components/Home')
const SellYourPark = () => import('@/components/SellYourPark')
const Login = () => import('@/components/Login')
const ForgotPassword = () => import('@/components/ForgotPassword')
const AnalyzerEdit = () => import('@/components/analyzer/AnalyzerEdit')
const AnalyzerReport = () => import('@/components/analyzer/AnalyzerReport')
const AnalyzerHome = () => import('@/components/analyzer/AnalyzerHome')
const AnalyzerList = () => import('@/components/analyzer/AnalyzerList')
const MarketScreener = () => import('@/components/markets/MarketScreener.vue')
const NotFound = () => import('@/components/NotFound')

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/sellyourpark',
      name: 'SellYourPark',
      component: SellYourPark
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/forgotPassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/mhp-analyzer',
      name: 'AnalyzerHome',
      component: AnalyzerHome
    },
    {
      path: '/mhp-analyzer/edit/:analysisId',
      name: 'AnalyzerEdit',
      component: AnalyzerEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/mhp-analyzer/report/:analysisId',
      name: 'AnalyzerReport',
      component: AnalyzerReport,
      props: true
      // meta: {
      //   requiresAuth: true
      // }
    },
    {
      path: '/mhp-analyzer/list',
      name: 'AnalyzerList',
      component: AnalyzerList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/market-screener',
      name: 'MarketScreener',
      component: MarketScreener,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/notfound',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (!to.matched.length) {
    next('/notfound')
  } else if (requiresAuth && !currentUser) {
    next('/login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js